import api from './api';

const prazoEntregaService = {
  // Listar prazos de entrega com paginação
  list: async (params = {}) => {
    try {
      const response = await api.get('/prazoentrega', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar prazos de entrega:', error);
      throw error;
    }
  },

  // Listar todos os prazos ativos para selects
  getAll: async () => {
    try {
      const response = await api.get('/prazoentrega/all');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar prazos de entrega:', error);
      throw error;
    }
  },

  // Buscar prazo por ID
  getById: async (id) => {
    try {
      const response = await api.get(`/prazoentrega/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar prazo de entrega:', error);
      throw error;
    }
  },

  // Criar novo prazo
  create: async (data) => {
    try {
      const response = await api.post('/prazoentrega', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar prazo de entrega:', error);
      throw error;
    }
  },

  // Atualizar prazo
  update: async (id, data) => {
    try {
      const response = await api.put(`/prazoentrega/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar prazo de entrega:', error);
      throw error;
    }
  },

  // Excluir prazo
  delete: async (id) => {
    try {
      const response = await api.delete(`/prazoentrega/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao excluir prazo de entrega:', error);
      throw error;
    }
  }
};

// Exports nomeados para compatibilidade com componentes existentes
export const getPrazoEntregas = prazoEntregaService.list;
export const getPrazoEntregaById = prazoEntregaService.getById;
export const createPrazoEntrega = prazoEntregaService.create;
export const updatePrazoEntrega = prazoEntregaService.update;
export const deletePrazoEntrega = prazoEntregaService.delete;

export default prazoEntregaService;
